import { SansText } from '../SansText/SansText'
import type { ErrorMessageProps } from './ErrorMessage.types'

export const ErrorMessage = ({ children }: ErrorMessageProps): JSX.Element => {
  return (
    <SansText center fontStyle="italic" color="error">
      {children}
    </SansText>
  )
}
